import React from "react";

export default function AmountBadge({ text, amount, onClickCallback, clicked }) {
    const badgeStyle = {
        backgroundColor: clicked ? "#ff6666" : "white",
        margin: 20,
        marginTop: 2,
        shadowRadius: 8,
        borderRadius: 30,
        textAlign: "center",
        height: 60,
        width: 130
    };

    return (
        <div onClick={() => onClickCallback()}>
            <div style={badgeStyle}>
                <div style={{ fontSize: 20 }}>{text}</div>
                <div
                    style={{
                        fontSize: 20,
                        fontWeight: "bold",
                        marginTop: "2px"
                    }}
                >
                    {amount}
                </div>
            </div>
        </div>
    );
}
